import { render, staticRenderFns } from "./CheckoutForm.vue?vue&type=template&id=56522c28&scoped=true&"
import script from "./CheckoutForm.vue?vue&type=script&lang=js&"
export * from "./CheckoutForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutForm.vue?vue&type=style&index=0&id=56522c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56522c28",
  null
  
)

export default component.exports